import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';

export function JudgesNotesSection({ form, index, updateGradeForm }) {
  return (
    <div className="mb-4 p-4 border rounded-lg bg-green-50">
      <div className="flex items-center justify-between mb-3">
        <h4 className="font-medium text-green-800">Judges Notes</h4>
        <label className="flex items-center gap-2 cursor-pointer text-sm">
          <Checkbox 
            checked={form.include_judges_notes_in_schedule}
            onCheckedChange={(val) => updateGradeForm(index, 'include_judges_notes_in_schedule', val)}
          />
          <span>Include in schedule documents?</span>
        </label>
      </div>
      <div className="space-y-3">
        <div>
          <Label className="text-sm">
            Judges notes for round 1
            {form.round_one_content_type === 'Competition Specific Event' && ' *'}
          </Label>
          <textarea 
            className="w-full border rounded-lg px-3 py-2 mt-1 min-h-[80px]"
            value={form.judges_notes_round_one}
            onChange={(e) => updateGradeForm(index, 'judges_notes_round_one', e.target.value)}
            placeholder={form.round_one_content_type === 'Competition Specific Event' ? 'Outline event content here' : ''}
            required={form.round_one_content_type === 'Competition Specific Event'}
          />
        </div>
        {form.round_two_content_type !== 'No Round Two' && (
          <div>
            <Label className="text-sm">Judges notes for round 2</Label>
            <textarea 
              className="w-full border rounded-lg px-3 py-2 mt-1 min-h-[80px]"
              value={form.judges_notes_round_two}
              onChange={(e) => updateGradeForm(index, 'judges_notes_round_two', e.target.value)}
            />
          </div>
        )}
      </div>
    </div>
  );
}
